/* Api Service
 ** Author: Cl-macmini-145
 ** Version: 1.0
 ** Date 27/03/2018 */

'use strict';

App.service('apiService', apiService);

function apiService($http, $q, $localStorage, $state, Api, ProfessionalService, userService) {
    /*this.Login = Login;*/
    this.getUserDataFromToken = getUserDataFromToken;
    this.regenerateLink = regenerateLink;
    this.textApp = textApp;
    // ==============================================
    // It needs to be changed to fully implement regenate link.
    function getUserDataFromToken(emailToken) {
        return userService
            .getBranding({ token: emailToken })
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error;
            });
    }

    // =========================================
    function regenerateLink(userEmail) {
        return userService
            .resendVerification({ email: userEmail })
    }

    // =========================================================
    function textApp(number) {
        const token = $localStorage['token'];
        return ProfessionalService.textMeApp(token, { number: number })
            .then(function (response) {
                return { message: 'Successfully send the app link!', data: {} };
            })
            .catch(function (error) {
                console.log('this is error');
                console.log(error);
            });
    }
}
